'use client';

import { useLocalStorage } from 'usehooks-ts';

import { SearchResult } from '@/app/(main)/_components/search-modal/search-modal.types';

const STORAGE_KEY = 'recent-searches';

export function useRecentSearchesStorage() {
  return useLocalStorage<SearchResult[]>(STORAGE_KEY, []);
}
